import PropTypes from "prop-types";
import "../dashboard-gpc/dashboard-gpc.scss";
import DashboardProjectTimeLog from "./dashboard-project-time-log/dashboard-project-time-log.jsx";
import DashboardMemberTimeLog from "./dashboard-member-time-log/dashboard-member-time-log.jsx";
import { DashboardGridSkeleton } from "../dashboard-skeletons/dashboard-skeletons.jsx";

const DashboardGPC = (props) => {
    return (
        <div>
            {props.isGPCMemberLoading 
              ?<DashboardGridSkeleton />
              :<DashboardMemberTimeLog items={props.memberItems} fetchData={props.fetchData} />
            }
            {props.isGPCProjectLoading 
              ?<DashboardGridSkeleton />
              :<DashboardProjectTimeLog items={props.projectItems} />
            }            
        </div>
    );
};

DashboardGPC.propTypes = {
  memberItems: PropTypes.shape({
    Item1: PropTypes.array,
    Item2: PropTypes.bool,
    Item3: PropTypes.number,
    Item4: PropTypes.number,
  }),
  projectItems: PropTypes.array,
  fetchData: PropTypes.func,
  isGPCMemberLoading: PropTypes.bool,
  isGPCProjectLoading: PropTypes.bool,
};

export default DashboardGPC;
